import React from "react"
import { motion } from "framer-motion"

import Lottie from "lottie-react"
import { FLEX_VARIANTS } from "/src/constants"

const FlexFace = ({isAnimated, color}) => (
  <motion.div
    animate={{
      rotate: isAnimated ? [0, -2, -5, 4, 7, 2, -4, 1, 5, -1, -6, 0] : 0
    }}
    transition={{
      loop: Infinity,
      type: "tween",
      duration: 3
    }}
  >
    <Lottie 
      animationData={FLEX_VARIANTS[color].face}
      autoplay={isAnimated}
      style={{
        height: '7rem',
        width: '7rem',
      }} 
    />
  </motion.div>
)

export default FlexFace